//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region types
import { DialogEnums, StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useDeleteConfirmation() {
  const dispatch = useDispatch();

  const deleteConfirmationDialog = (
    onDelete: () => Promise<any>,
    onContinueEditing?: () => Promise<any>
  ): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AutomationRule.DeleteConfirmationTitle),
    titleIcon: IconDefinitionConstants.WInfo,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Delete),
        onClick: onDelete,
        type: StyleEnums.DisplayType.Danger,
      },
    ],
    hideCloseButton: true,
    dialogType: DialogEnums.DialogType.Message,
    children: LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.AutomationRule.DeleteConfirmationDescription
    ),
    type: StyleEnums.DisplayType.Info,
    onClose: onContinueEditing,
  });

  const showDeleteConfirmation = (onDelete: () => Promise<any>, onContinueEditing?: () => Promise<any>) => {
    dispatch(displayDialog(deleteConfirmationDialog(onDelete, onContinueEditing)));
  };

  return { showDeleteConfirmation, deleteConfirmationDialog };
}

export default useDeleteConfirmation;
